import { rtdbNBAService } from "../rtdb/rtdbNBAService";

export default rtdbNBAService;
